<template>
  <div class="customer-timeline container-fluid">

    <customer-show-history-entry ref="showentry" :customer="customer" :readonly="!can_edit_history"
      @submit="loadTimeline"></customer-show-history-entry>

    <customer-show-document @submit="loadTimeline" ref="showdocument" :customer="customer">
    </customer-show-document>

    <agenda-show-appointment @submit="loadTimeline" ref="showapp" locked="true">
    </agenda-show-appointment>

    <customer-show-treatment ref="showtreatment" :customer="customer" :clinic="clinic" @submit="loadTimeline">
    </customer-show-treatment>

    <div class="customer-timeline__topbar row" id="topbar">

      <div class="col d-flex align-items-start justify-content-start">
        <v-select style="flex: 1 1 320px" ref="psearch" class="wabident-selector filter" :options="products"
          :filterable="true" placeholder="Filtrar por tratamiento/producto ..." v-model="selected_product"></v-select>
      </div>

      <div class="col-md-1" v-if="is_dental">
        <single-tooth-selector v-model="tooth" style="padding: 8px 12px"></single-tooth-selector>
        <label for="customer_timeline_tooth" class="wabident-info">Pieza</label>
      </div>

      <div class="col-md-2">
        <select id="customer_timeline_doctor_id" v-model="doctor_id" class="custom-select" style="padding: 8px 12px">
          <option :value="null">Tod@s</option>
          <option v-for="doctor in active_doctors" :key="doctor.id" :value="doctor.id">{{ doctor.name }}</option>
        </select>
        <label for="customer_timeline_period" class="wabident-info">Profesional</label>
      </div>

      <div class="col-md-2">
        <select id="customer_timeline_period" v-model="period" class="custom-select" style="padding: 8px 12px">
          <option :value="null">Todas las fechas</option>
          <option value="week">Esta semana</option>
          <option value="week_prior">Semana pasada</option>
          <option value="month">Este mes</option>
          <option value="month_prior">Mes pasado</option>
          <option value="trimester">Este trimestre</option>
          <option value="trimester_prior">Trimestre pasado</option>
          <option value="year">Este año</option>
          <option value="past_year">Año pasado</option>
          <option value="custom">Personalizado</option>
        </select>
        <label for="customer_timeline_period" class="wabident-info">Periodo</label>
      </div>

      <transition name="fade">
        <div class="col-md-2" v-if="period == 'custom'">
          <input v-model="date_from" id="customer_timeline_date_from" type="date" class="form-control"
            style="padding: 8px 12px" />
          <label class="wabident-info" for="customer_timeline_date_from">Desde:</label>
        </div>
      </transition>

      <transition name="fade">
        <div class="col-md-2" v-if="period == 'custom'">
          <input v-model="date_to" id="customer_timeline_date_to" type="date" class="form-control"
            style="padding: 8px 12px" />
          <label class="wabident-info" for="customer_timeline_date_to">Hasta:</label>
        </div>
      </transition>

      <div class="col">
        <button type="button" @click="addNewHistoryEntry" class="btn btn-wabident-round float-right mt-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <g clip-path="url(#clip0_203_1328)">
              <path
                d="M10.4508 5.05079L6.94923 5.05079L6.94923 1.54923C6.94923 1.29748 6.84922 1.05604 6.67121 0.878026C6.49319 0.700013 6.25176 0.600007 6.00001 0.600007C5.74826 0.600007 5.50682 0.700013 5.32881 0.878026C5.15079 1.05604 5.05079 1.29748 5.05079 1.54923L5.05079 5.05079L1.54922 5.05079C1.29748 5.05079 1.05604 5.15079 0.878025 5.32881C0.700012 5.50682 0.600006 5.74826 0.600006 6.00001C0.600006 6.25175 0.700012 6.49319 0.878025 6.6712C1.05604 6.84922 1.29748 6.94922 1.54922 6.94922L5.05079 6.94922L5.05079 10.4508C5.05079 10.7025 5.15079 10.944 5.32881 11.122C5.50682 11.3 5.74826 11.4 6.00001 11.4C6.25175 11.4 6.49319 11.3 6.6712 11.122C6.84922 10.944 6.94922 10.7025 6.94922 10.4508L6.94922 6.94923L10.4508 6.94923C10.7025 6.94923 10.944 6.84922 11.122 6.67121C11.3 6.49319 11.4 6.25176 11.4 6.00001C11.4 5.74826 11.3 5.50682 11.122 5.32881C10.944 5.15079 10.7025 5.05079 10.4508 5.05079Z"
                fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_203_1328">
                <rect width="12" height="12" fill="white" />
              </clipPath>
            </defs>
          </svg>
          Nota
        </button>

        <button type="button" @click="addNewLabWork" class="btn btn-wabident-round float-right mt-1 mx-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <g clip-path="url(#clip0_203_1328)">
              <path
                d="M10.4508 5.05079L6.94923 5.05079L6.94923 1.54923C6.94923 1.29748 6.84922 1.05604 6.67121 0.878026C6.49319 0.700013 6.25176 0.600007 6.00001 0.600007C5.74826 0.600007 5.50682 0.700013 5.32881 0.878026C5.15079 1.05604 5.05079 1.29748 5.05079 1.54923L5.05079 5.05079L1.54922 5.05079C1.29748 5.05079 1.05604 5.15079 0.878025 5.32881C0.700012 5.50682 0.600006 5.74826 0.600006 6.00001C0.600006 6.25175 0.700012 6.49319 0.878025 6.6712C1.05604 6.84922 1.29748 6.94922 1.54922 6.94922L5.05079 6.94922L5.05079 10.4508C5.05079 10.7025 5.15079 10.944 5.32881 11.122C5.50682 11.3 5.74826 11.4 6.00001 11.4C6.25175 11.4 6.49319 11.3 6.6712 11.122C6.84922 10.944 6.94922 10.7025 6.94922 10.4508L6.94922 6.94923L10.4508 6.94923C10.7025 6.94923 10.944 6.84922 11.122 6.67121C11.3 6.49319 11.4 6.25176 11.4 6.00001C11.4 5.74826 11.3 5.50682 11.122 5.32881C10.944 5.15079 10.7025 5.05079 10.4508 5.05079Z"
                fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_203_1328">
                <rect width="12" height="12" fill="white" />
              </clipPath>
            </defs>
          </svg>
          Trabajo Lab.
        </button>

        <button type="button" @click="printHistory" class="btn btn-wabident-round float-right mt-1 mx-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M16.75 7.75V3.71582C16.75 3.41734 16.6315 3.13152 16.4206 2.92023L14.8294 1.32941C14.6185 1.11848 14.3323 1 14.0338 1H4.375C3.75379 1 3.25 1.50379 3.25 2.125V7.75C2.00723 7.75 1 8.75723 1 10V13.9375C1 14.2483 1.25172 14.5 1.5625 14.5H3.25V17.875C3.25 18.4962 3.75379 19 4.375 19H15.625C16.2462 19 16.75 18.4962 16.75 17.875V14.5H18.4375C18.7483 14.5 19 14.2483 19 13.9375V10C19 8.75723 17.9928 7.75 16.75 7.75ZM14.5 16.75H5.5V13.375H14.5V16.75ZM14.5 8.875H5.5V3.25H12.25V4.9375C12.25 5.24828 12.5017 5.5 12.8125 5.5H14.5V8.875ZM16.1875 11.4062C15.7217 11.4062 15.3438 11.0283 15.3438 10.5625C15.3438 10.0963 15.7217 9.71875 16.1875 9.71875C16.6533 9.71875 17.0312 10.0963 17.0312 10.5625C17.0312 11.0283 16.6533 11.4062 16.1875 11.4062Z"
              fill="#A6AAB4" />
          </svg>
          &nbsp;
        </button>
      </div>
    </div>

    <div class="customer-timeline__pinned row" :class="{ 'has-events': pinned_events.length }">
      <div class="col-md-12">
        <strong>DESTACADOS</strong>
      </div>
      <customer-timeline-pinned-event v-for="(event, key) in pinned_events" @pin="pinEvent" @edit="editEvent"
        @done="doneTreatment" @note="noteTreatment" @expand="pinned_event = key" @close="pinned_event = null"
        @appointment="appointTreatment" :doctor_names="doctor_names" :event="event" :entity="getEventEntity(event)"
        @assign="assignTreatment" :key="key" :clinic="clinic" :expanded="pinned_event == key">
      </customer-timeline-pinned-event>
    </div>

    <div v-if="filtered_events.length" class="customer-timeline__events" style="position: relative;"
      @click="pinned_event = null">
      <div class="mb-3" style="margin-left: 5px;">
        <strong>HISTORIAL</strong>
      </div>

      <customer-timeline-event @pin="pinEvent" @edit="editEvent" @done="doneTreatment" @note="noteTreatment"
        @assign="assignTreatment" @appointment="appointTreatment" v-for="(event, key) in filtered_events"
        :doctor_names="doctor_names" :key="key" :event="event" :entity="getEventEntity(event)"
        :clinic="clinic"></customer-timeline-event>
      <a class="customer-timeline__gototop" @click="gotoTop">
        <i class="fas fa-chevron-up"></i>
      </a>
    </div>

    <div class="customer-timeline__no-events" v-else>
      <span v-if="timeline.events && timeline.events.length">
        Tu búsqueda no produjo resultados. Por famor amplía los términos
      </span>
      <span v-else>
        No hay entradas en la historia clínica. Añade un plan al paciente o usa otros términos de búsqueda
      </span>
    </div>

  </div>
</template>

<script>
export default {
  props: ['customer'],
  data() {
    return {
      is_loading: false,
      timeline: {},
      selected_product: null,
      events_per_page: 5,
      current_page: 1,
      pinned_event: null,
      date_from: null,
      date_to: null,
      tooth: 0,
      doctor_id: null,
      period: null,
    };
  },
  computed: {
    timeline_group_events() {
      return this.clinic && this.clinic.config && this.clinic.config.timeline_group_events;
    },
    pagination_links() {
      let ret = [];
      for (let i = 1; i <= this.total_pages; i++) {
        ret.push({
          label: i,
          page: i
        });
      }
      return ret;
    },
    total_pages() {
      return Math.ceil(this.filtered_events.length / this.events_per_page);
    },
    paged_events() {
      let start_index = Math.floor(this.current_page - 1 / this.events_per_page) * this.events_per_page;
      return this.filtered_events.slice(start_index, start_index + this.events_per_page);
    },
    pinned_events() {
      if (!this.timeline.events) return [];
      let ret = this.timeline.events.filter(e => e.pinned);
      return ret;
    },
    filtered_events() {
      if (!this.timeline.events) return [];

      let ret = this.timeline.events;
      const today = moment().utc().endOf('day');

      ret = ret.filter((ev) => {
        if (ev.entity == 'Appointment' && !ev.pinned) {
          return moment(ev.date).utc().isSameOrBefore(today);
        }
        return true;
      });

      /* If Timeline Event Grouping is Enabled, discard Done Treatment Events */
      if (this.timeline_group_events) {
        ret = ret.filter((ev) => {

          if (ev.entity == 'Quotation') {
            return false;
          }

          if (ev.entity == 'Treatment' && ev.action == 'DONE') {
            const obj = this.getEventEntity(ev);
            const is_appointed = obj.appointments && (obj.appointments.length > 0);
            return !is_appointed;
          }


          return true;
        });
      }

      if (this.date_from) {
        const dfrom = moment(this.date_from).utc().startOf('day');
        ret = ret.filter((event) => {
          return moment(event.date).utc().isSameOrAfter(dfrom);
        });
      }

      if (this.date_to) {
        H
        const dto = moment(this.date_to).utc().endOf('day');
        ret = ret.filter((event) => {
          return moment(event.date).utc().isSameOrBefore(dto);
        });
      }

      if (this.doctor_id) {
        ret = ret.filter((ev) => {
          const entity = this.getEventEntity(ev);
          let found = (entity.doctor_id == this.doctor_id);

          if (!found && entity.treatments) {
            entity.treatments.forEach((treatment) => {
              found = found || (this.doctor_id == treatment.doctor_id);
            });
          }

          return found;
        });
      }

      if (this.tooth) {
        ret = ret.filter((ev) => {
          let found = false;
          const entity = this.getEventEntity(ev);

          if (entity.teeth && Array.isArray(entity.teeth)) {
            found = entity.teeth.includes(Number(this.tooth)) || entity.teeth.includes(String(this.tooth));
          }

          if (!found && Array.isArray(entity.treatments)) {
            entity.treatments.forEach((treatment) => {
              found = found || treatment.teeth.includes(Number(this.tooth)) || treatment.teeth.includes(String(this.tooth));
            });
          }

          return found;
        });

      }

      if (this.selected_product) {
        const product_id = this.selected_product.value.id;
        ret = ret.filter((event) => {
          const entity = this.getEventEntity(event);

          if (entity.product_id) {
            return entity.product_id == product_id;
          }

          if (entity.treatments) {
            let found = false;
            entity.treatments.forEach((treatment) => {
              found = found || (product_id == treatment.product_id);
            });
            return found;
          }

          return false;
        });
      }


      return ret;
    },
    can_edit_history() {
      if (!this.clinic) return false;
      return this.clinic.capabilities["edit-history-entries"] || false;
    },
    products() {
      if (!this.timeline.treatments) return [];

      let product_dict = {};
      for (const treatment_id in this.timeline.treatments) {
        const t = this.timeline.treatments[treatment_id];
        product_dict[t.product.id] = t.product;
      }

      let ret = [];
      for (const product_id in product_dict) {
        const product = product_dict[product_id];
        ret.push({
          label: product.name,
          value: product
        });
      }

      return ret;
    },
    doctors() {
      if (!this.clinic || !this.clinic.doctors) {
        return [];
      }

      return this.clinic.doctors.map(u => {
        return {
          name: u.name,
          active: u.doctor ? u.is_active : false,
          id: u.doctor ? u.doctor.id : null,
        }
      });
    },
    active_doctors() {
      return this.doctors.filter(d => {
        return d.active;
      });
    },
    doctor_names() {
      let ret = {};
      if (this.clinic && this.clinic.doctors) {
        this.clinic.doctors.forEach((d) => {
          if (d.doctor) {
            ret[d.doctor.id] = d.name;
          }
        });
      }
      return ret;
    },
    is_dental() {
      if (!this.clinic) return false;
      if (!this.clinic.type) return false;
      if (this.clinic.type == "dental") return true;
      return false;
    },
    ...mapGetters(['clinic', 'errowindow', 'msgwindow'])
  },
  watch: {
    selected_product() {
      this.current_page = 1;
    },
    period(value) {
      if (value == null) {
        this.date_from = null;
        this.date_to = null;
      } else if (value !== 'custom') {
        const dates = window.WabiDent.periodDates(value);
        this.date_from = dates.date_from.toISODate();
        this.date_to = dates.date_to.toISODate();
      }
      this.current_page = 1;
      this.loadTimeline();
    }
  },
  methods: {
    gotoTop() {
      document.getElementById('topbar').scrollIntoView({
        behavior: 'smooth'
      });
    },
    computePinnedQuotEvents() {
      if (!this.timeline) {
        return;
      }

      let quotations = this.timeline.events.filter((e) => {
        return e.entity == 'Quotation';
      })

      quotations.forEach((event) => {
        let quotation = this.getEventEntity(event);
        let approved = true;
        let all_done = true;

        quotation.treatments.forEach((treatment) => {
          approved = approved || treatment.is_approved;
          all_done = all_done && (treatment.status == 'done' || treatment.status == 'done_prior');
        });

        if (approved && !all_done) {
          event.pinned = true;
          event.unpinnable = true;
        };
      });
    },
    computePinnedAppEvents() {
      if (!this.timeline) {
        return;
      }

      let now = moment().utc();
      let prev_event = null;
      let cur_event = null;

      let appointments = this.timeline.events.filter((e) => {
        return e.entity == 'Appointment';
      })

      appointments.every((event) => {
        cur_event = prev_event;
        prev_event = event;
        if (moment(prev_event.date).utc().isBefore(now)) {
          return false;
        }
        return true;
      });

      if (cur_event) {
        cur_event.pinned = true;
        cur_event.unpinnable = true;
      }

      if (prev_event) {
        prev_event.pinned = true;
        prev_event.unpinnable = true;
      }
    },
    getEventEntity(event) {
      switch (event.entity) {
        case 'Quotation':
          return this.timeline.quotations[event.id];
        case 'Treatment':
          return this.timeline.treatments[event.id];
        case 'Appointment':
          return this.timeline.appointments[event.id];
        case 'HistoryEntry':
          return this.timeline.entries[event.id];
        case 'LabWork':
          return this.timeline.lab_works[event.id];
      }
      return null;
    },
    goPrev() {
      this.current_page = Math.max(this.current_page - 1, 1);
      this.pinned_event = null;
    },
    goNext() {
      this.current_page = Math.min(this.current_page + 1, this.total_pages);
      this.pinned_event = null;
    },
    gotoPage(page) {
      if (page) {
        this.current_page = Math.max(Math.min(page, this.total_pages), 1);
        this.pinned_event = null;
      }
    },
    loadTimeline() {
      axios.get(`/customer/${this.customer.id}/events`)
        .then((response) => {
          this.timeline = response.data;
          this.computePinnedAppEvents();
          this.computePinnedQuotEvents();
        }).catch((error) => {
          console.log('[loadTimeLine] ERROR - ', error);
          this.msgwindow.error('Error cargando feed !');
        }).then(() => {
          this.pinned_event = null;
        });
    },
    addNewHistoryEntry() {
      this.pinned_event = null;
      this.$refs.showentry.showNew();
    },
    addNewLabWork() {
      this.pinned_event = null;
      this.$refs.showdocument.showNew(this.customer, null, null, null, 'lab_work');
    },
    printHistory() {
      window.open(`/customer/${this.customer.id}/history_pdf`, '_blank');
    },
    editEvent(event, entity) {
      this.pinned_event = null;
      switch (event.entity) {
        case 'HistoryEntry':
          this.$refs.showentry.showEdit(entity);
          break;
        case 'CustomerDocument':
          this.$refs.showdocument.showEdit(this.customer, entity);
          break;
        case 'Appointment':
          entity.customer = this.customer;
          this.$refs.showapp.showEdit(entity, true);
          break;
        case 'LabWork':
          this.$refs.showdocument.showEdit(this.customer, entity);
          break;
      }
    },
    assignTreatment(event, entity) {
      this.$refs.showtreatment.showEdit(entity);
      this.pinned_event = null;
    },
    doneTreatment(event, treatment) {
      if (this.is_loading) return;
      this.is_loading = true;

      axios.post(`/customer/${this.customer.id}/treatment/${treatment.id}/done`)
        .then(() => {
          this.msgwindow.success('Tratamiento actualizado');
        }).catch((err) => {
          console.log(err);
          this.msgwindow.error('Error actualizando tratamiento');
        }).then(() => {
          this.is_loading = false;
          this.pinned_event = null;
          this.loadTimeline();
        });
    },
    noteTreatment(event, treatment) {
      this.$refs.showentry.showNew(treatment);
      this.pinned_event = null;
    },
    appointTreatment(event, treatment) {
      this.$refs.showapp.showNew(this.customer);
    },
    pinEvent(event) {
      if (this.is_loading) return;
      this.is_loading = true;

      axios.post(`/customer/${this.customer.id}/pin_event`, event)
        .then(() => {
          this.msgwindow.success('Evento actualizado');
        }).catch((err) => {
          console.log(err);
          this.msgwindow.error('Error actualizando evento');
        }).then(() => {
          this.is_loading = false;
          this.pinned_event = null;
          this.loadTimeline();
        });

    },
    appointEvent(event, treatment) {
    },
  },
  mounted() {
    this.loadTimeline()
  }
}
</script>

<style lang="scss">
.customer-timeline {
  &__topbar {
    margin-top: 20px;
  }

  &__pinned {
    padding-left: 15px;
    padding-right: 15px;

    &>[class*="col-"] {
      padding-right: 5px;
      padding-left: 5px;
    }
  }

  &__events {
    margin-top: 20px;
  }

  &__pagination {
    padding: 5px;

    &>* {
      margin: 5px;
    }
  }

  &__prev,
  &__next {
    transition: .3s;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 18px;
      height: 18px;

      path {
        fill: var(--theme-color);
      }
    }

    &:hover {
      opacity: 0.7;
    }
  }

  &__pagination-link {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 700;
    background: transparent;
    border-radius: 16px;
    text-decoration: none !important;
    color: var(--theme-text-color);
    transition: .3s;


    &.current,
    &:hover {
      color: white;
      background: var(--theme-color);
    }

  }

  &__no-events {
    font-size: 20px;
    text-align: center;
    font-weight: bold;
    padding: 50px 50px;
  }


  &__gototop {
    display: flex;
    position: sticky;
    bottom: 10px;
    float: right;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    align-items: center;
    justify-content: center;
    color: white;
    cursor: pointer;
    background: var(--theme-color);
    transition: .3s;

    &:hover {
      color: white;
      opacity: 0.8;
      text-decoration: none;
    }
  }
}
</style>
